const CryptoJS = require('crypto-js');

const decrypt = (word, privatekey) => {
  //let privatekey = HttpHeader.getEncryptionKey();
  //let privatekey = 'bcf1dd2c04b890688a1c8ed0b2d1ffdb';
  const key = CryptoJS.enc.Utf8.parse(privatekey);
  console.log('key: ', key);
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  console.log('decrypt: ', decrypt.toString(CryptoJS.enc.Utf8));
  const decryptedData = JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));
  console.log('decryptedData: ', decryptedData);
  return decryptedData;
};

const Decryption = (data, key) => {
  const decryptedData = decrypt(data, key);
  console.log('decrypted Data -');
  console.log(decryptedData);
  return decryptedData;
};
export default Decryption;
